import React from 'react';

function Logo({ size = 48, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="logoBg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#1c1c1e' }} />
          <stop offset="100%" style={{ stopColor: '#0d0d0e' }} />
        </linearGradient>
        <linearGradient id="logoBookmark" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#2d5a46' }} />
          <stop offset="85%" style={{ stopColor: '#346751' }} />
          <stop offset="100%" style={{ stopColor: '#4a9070' }} />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="100" fill="url(#logoBg)" />
      <path
        d="M171 90 L341 90 Q361 90 361 110 L361 410 L256 340 L151 410 L151 110 Q151 90 171 90 Z"
        fill="url(#logoBookmark)"
      />
      <rect x="196" y="150" width="28" height="70" rx="14" fill="#ECDBBA" />
      <rect x="242" y="130" width="28" height="110" rx="14" fill="#ECDBBA" />
      <rect x="288" y="145" width="28" height="80" rx="14" fill="#ECDBBA" />
    </svg>
  );
}

export default Logo;
